import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chips: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    deletableChips: {
      maxWidth: "200px",
    },
    UndeletableChips: {
      maxWidth: "150px", 
    },
  })
);
